import './style.css'
import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import TextSpriteTimer from './modules/TextSpriteTimer';
import BgGradient from './modules/background/BgGradient';
import Project from './Project';
import Bloom from './postprocessing/Bloom2';
import Particles from './modules/particles/Particles';
import { checkHash, lerp, isMobile } from './utils/utils';
import { createParticle } from './genereator';
import Noise from './postprocessing/Noise';
import gsap from 'gsap';
import { TextureLoader } from 'three';
import {initSlack} from './utils/slack';

initSlack();

const LAYER_STENCIL = 10;
const LAYER_PORTAL = 11;

const project = new Project();
const sourcePath = (typeof globalPath !== 'undefined')?globalPath:'';

const hashtags = {
    debug:checkHash('#debug'),
    stats:checkHash('#stats'),
}

const objects = {
    background:null,
    particles:null,
    bloom:null, 
}

const guiParams = {

    layerData:['all', 'normal', 'bloom', 'stencil', 'portal'],
    layer:'all',

    //
    bgBtmColor:'#000000',
    bgTopColor:'#2a041c',
}

const gltfLoader = new GLTFLoader();
const texLoader = new THREE.TextureLoader();


function initScene(){

    window.THREE_ = project;
    project.camera.position.set(0, 0, 10);
    project.renderer.autoClear = false;
    project.initControls();
    hashtags.stats && project.initStatsJs();

    //
    objects.bloom = new Bloom(project.scene, project.camera, project.renderer);
    //objects.noise = new Noise(project.scene, project.camera, project.renderer);

    project.onResize = (width, height, pixelRatio) => {
        objects.bloom.resize(width, height, pixelRatio);
    }

    //
    if(isMobile()){
        project.camera.position.z -= 4;
    }
}


function initEventListener(){

    const duration = 0.5;

    project.canvas.addEventListener('mousedown', () => {
        gsap.to(objects.text.material, {opacity:0, duration});
    });

    project.canvas.addEventListener('mouseup', () => {
        gsap.to(objects.text.material, {opacity:1, duration});
    });

    project.canvas.addEventListener('touchstart', () => {
        gsap.to(objects.text.material, {opacity:0, duration});
    }, {passive:true});

    project.canvas.addEventListener('touchend', () => {
        gsap.to(objects.text.material, {opacity:1, duration});
    }, {passive:true});

    /*
    project.canvas.addEventListener('click', (e) => {

        if(e.x < window.innerWidth/10 && e.y < window.innerHeight/10){
            throw new Error('Throw error for test');
        }
    });
    */
}


function initObjects(){

    //
    loadIntroModel();

    const stencilGeo = new THREE.PlaneGeometry(10, 2);

    //stencil object
    const mesh = new THREE.Mesh(
        stencilGeo,
        new THREE.MeshBasicMaterial({
            color:0x000000,
            side:THREE.DoubleSide
        })
    );

    mesh.position.z = 1;
    mesh.layers.set(LAYER_STENCIL);
    project.scene.add(mesh);

    //bloom object
    const mesh2 = new THREE.Mesh(
        stencilGeo,
        new THREE.MeshBasicMaterial({
            color:0xbe0a5f,
            side:THREE.DoubleSide,
        })
    );

    mesh2.position.z = 1;
    mesh2.scale.setScalar(0.99);
    mesh2.layers.enable(Bloom.BLOOM_LAYER);
    project.scene.add(mesh2);

    //
    const textMesh = new TextSpriteTimer();
    textMesh.setDDay(2022, 5, 31);

    textMesh.allMeshes.forEach(text => {
        text.layers.set(LAYER_PORTAL);
        project.scene.add(text);
    })

    //
    const radius = 100;

    const bg = new BgGradient();
    bg.setSize(radius);
    bg.setColor(guiParams.bgBtmColor, guiParams.bgTopColor);
    project.scene.add(bg);
    objects.background = bg;
    
    //
    objects.stars = createParticle(radius);
    project.scene.add(objects.stars);
    const particleTex = texLoader.load(sourcePath+'./texture/particleMask.png');
    objects.particles = new Particles(project.scene, particleTex);
    objects.particles.points.layers.enable(LAYER_PORTAL);
    

}


function loadIntroModel(){

    const map01 = texLoader.load(sourcePath+'./texture/boxTexture.jpg');
    map01.flipY = false;

    const inMaterial = new THREE.MeshBasicMaterial({
        map:map01,color:0xbe0a5f
    });

    //
    gltfLoader.load(sourcePath+'./model/intro.glb', gltf => {

        project.scene.add(gltf.scene);
        
        gltf.scene.traverse((o) => {

            o.layers.set(LAYER_PORTAL);

            if (o.isMesh) {
                o.material = inMaterial;
            }
                
            o.castShadow = true;
            o.receiveShadow = true;
        });
    });

    //
    const textMap = texLoader.load(sourcePath+'./texture/intro_text.png');
    textMap.flipY = false;
    //textMap.encoding = THREE.sRGBEncoding;
    textMap.minFilter = THREE.LinearFilter;
    textMap.wrapS = THREE.RepeatWrapping;
    textMap.wrapT = THREE.RepeatWrapping;

    gltfLoader.load(sourcePath+'./model/intro_text.glb', gltf => {
        
        gltf.scene.position.y = 4.9;
        gltf.scene.position.x = 0.3;
        gltf.scene.scale.set(1.6,1.6,1.6);

        project.scene.add(gltf.scene);

        objects.text = gltf.scene.children[0];
        objects.text.material.map = textMap;
        objects.text.material.emissiveMap = textMap;
    });
}




function initDebugGUI(){

    if(hashtags.debug){

        let folder = project.gui.addFolder('Scene Layers');
        folder.add(guiParams, 'layer', guiParams.layerData);

        //
        folder = project.gui.addFolder('Background');

        folder.addColor(guiParams, 'bgTopColor').onChange(v => {
            objects.background.setColor(null, v);
        });
        folder.addColor(guiParams, 'bgBtmColor').onChange(v => {
            objects.background.setColor(v, null);
        });

        //        
        objects.bloom.initDebugGUI(project.gui);
        objects.particles.initDebugGUI(project.gui);
    }
    
    //
    if(project.gui.children.length == 0){
        project.gui.hide();
    }
}


let textValues = {
    interval : 5,   //초마다 변경
    duration : 1,   //초동안 업데이트
    elapsed : 0,
    isTweening:false,

    index:0,
    unit:1/8,
}

function updateText(delta){

    if(!objects.text){
        return;
    }

    //no tween
    const {interval, elapsed, index, unit} = textValues;
    textValues.elapsed += delta;

    if(elapsed > interval){

        const newIndex = (index+1) % 8;
        objects.text.material.map.offset.y = newIndex * unit;

        textValues.index = newIndex;
        textValues.elapsed = 0;
    }

    /*
    //tween offset
    const {interval, duration, elapsed, isTweening, index, unit} = textValues;
    textValues.elapsed += delta;

    if(isTweening){

        const start = index * unit;
        const end = start + unit;
        objects.text.material.map.offset.y = lerp(start, end, elapsed/duration);

        if(elapsed >= duration){
            textValues.elapsed = 0;
            textValues.isTweening = false;
            textValues.index = (index+1) % 8;
        }

    }else{

        if(elapsed >= interval){
            textValues.elapsed = 0;
            textValues.isTweening = true;
        }
    }
    */
}


function render(deltaTime){

    const {renderer, scene, camera} = project;
    // const {width, height, pixelRatio} = {
    //     width:window.innerWidth,
    //     height:window.innerHeight,
    //     pixelRatio:Math.min(window.devicePixelRatio, 2)
    // };

    // renderer.setSize(width,height);
    // renderer.setPixelRatio(pixelRatio);

    var gl = renderer.getContext();
    gl.enable(gl.STENCIL_TEST);
    gl.depthMask(false);

    //clear buffer
    gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT | gl.STENCIL_BUFFER_BIT);

    //draw portal
    gl.stencilFunc(gl.ALWAYS, 1, 0xff);
    gl.stencilOp(gl.KEEP, gl.KEEP, gl.REPLACE);
    
    let mask = camera.layers.mask;
    camera.layers.set(LAYER_STENCIL);
    renderer.render(scene, camera);
    camera.layers.mask = mask;
    
    //draw inside
    gl.stencilFunc(gl.EQUAL, 1, 0xff);
    gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
    
    gl.depthMask(true);
    camera.layers.set(LAYER_PORTAL);
    renderer.render(scene, camera);
    // objects.noise.render(renderer, scene, camera, deltaTime);
    camera.layers.mask = mask;

    //draw outside
    gl.stencilFunc(gl.EQUAL, 0, 0xff);
    gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);

    renderer.render(scene, camera);
    //objects.bloom.render(renderer, scene, camera, deltaTime);

    //
    gl.disable(gl.STENCIL_TEST);
    gl.depthMask(true);
}


/**
 * Animate
 */
const clock = new THREE.Clock();
let prevTime = 0;

const tick = () => {

    const elapsedTime = clock.getElapsedTime();
    const deltaTime = elapsedTime - prevTime;
    prevTime = elapsedTime;

    // Update controls
    project.update();
    objects.particles?.update(elapsedTime);
    updateText(deltaTime);

    // Render
    const idx = guiParams.layerData.findIndex(i => i == guiParams.layer);
    const {renderer, scene, camera} = project;
    const backupMask = camera.layers.mask;

    switch(idx){

        case 0:
            render(deltaTime);
            break;

        case 1:
            renderer.render(scene, camera);
            break;

        case 2:
            camera.layers.set(Bloom.BLOOM_LAYER);
            renderer.render(scene, camera);
            camera.layers.mask = backupMask;
            break;

        case 3:
            camera.layers.set(LAYER_STENCIL);
            renderer.render(scene, camera);
            camera.layers.mask = backupMask;
            break;

        case 4:
            camera.layers.set(LAYER_PORTAL);
            renderer.render(scene, camera);
            camera.layers.mask = backupMask;
            break;
    }
    
    // Call tick again on the next frame
    window.requestAnimationFrame(tick);
}

initScene();
initEventListener();
initObjects();
initDebugGUI();
tick();